<template>
    <SwiperSlider 
        v-if="campaigns.length"
        type="recommendations" 
        :campaigns="campaigns" 
        title="Recommendations"/>
</template>

<script>
    import SwiperSlider from '../SwiperSlider/index.vue'
    import useRecommendations from './useRecommendations'
    export default {
        name: "Recommendations",
        setup() {
            const {
                campaigns
            } = useRecommendations();
            return {
                campaigns,
            };
        },
        components: {
            SwiperSlider
        },
    };
</script>